import apiHandler from "../core/apiHandler";

const exportRegimeApi = apiHandler('export-regimes');
export default exportRegimeApi;
